import React, { useState } from 'react';
import './HomePage.css';

export default function HomePage({ onSelect }) {
  const [hovering, setHovering] = useState(null);

  return (
    <div className="home-page">
      {/* Background grid */}
      <div className="bg-grid" />

      {/* Header */}
      <header className="home-header">
        <div className="logo">
          <span className="logo-icon">⬡</span>
          <span className="logo-text">SENTINEL</span>
          <span className="logo-version">v1.0</span>
        </div>
        <div className="header-status">
          <span className="dot green" />
          <span className="status-text">SISTEMA OPERATIVO</span>
        </div>
      </header>

      {/* Main */}
      <main className="home-main">
        <div className="title-block animate-in">
          <p className="subtitle">SISTEMA DE VIDEOVIGILANCIA PERSONAL</p>
          <h1 className="title">Selecciona el modo</h1>
          <p className="description">
            Convierte cualquier dispositivo en parte de tu sistema de seguridad doméstica
          </p>
        </div>

        <div className="mode-grid animate-in" style={{ animationDelay: '0.1s' }}>
          {/* Camera Mode */}
          <button
            className={`mode-card camera-card ${hovering === 'camera' ? 'is-hovered' : ''}`}
            onMouseEnter={() => setHovering('camera')}
            onMouseLeave={() => setHovering(null)}
            onClick={() => onSelect('camera')}
          >
            <div className="card-corner tl" />
            <div className="card-corner tr" />
            <div className="card-corner bl" />
            <div className="card-corner br" />

            <div className="card-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                <path d="M15 10l4.553-2.069A1 1 0 0121 8.82v6.362a1 1 0 01-1.447.894L15 14M3 8a2 2 0 012-2h10a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2V8z"/>
              </svg>
            </div>
            <div className="card-label">MODO CÁMARA</div>
            <div className="card-title">Dispositivo Emisor</div>
            <div className="card-desc">
              Este dispositivo captura y emite vídeo + audio en tiempo real. Detección de movimiento automática.
            </div>
            <div className="card-features">
              <span>📹 Vídeo HD</span>
              <span>🔊 Audio</span>
              <span>🔍 Detección movimiento</span>
            </div>
            <div className="card-cta">ACTIVAR CÁMARA →</div>
          </button>

          {/* Viewer Mode */}
          <button
            className={`mode-card viewer-card ${hovering === 'viewer' ? 'is-hovered' : ''}`}
            onMouseEnter={() => setHovering('viewer')}
            onMouseLeave={() => setHovering(null)}
            onClick={() => onSelect('viewer')}
          >
            <div className="card-corner tl" />
            <div className="card-corner tr" />
            <div className="card-corner bl" />
            <div className="card-corner br" />

            <div className="card-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                <rect x="2" y="3" width="20" height="14" rx="2"/>
                <path d="M8 21h8M12 17v4"/>
                <circle cx="7" cy="10" r="1" fill="currentColor"/>
                <rect x="10" y="7" width="8" height="6" rx="1"/>
              </svg>
            </div>
            <div className="card-label">MODO VISUALIZADOR</div>
            <div className="card-title">Panel de Control</div>
            <div className="card-desc">
              Monitoriza todas las cámaras en tiempo real. Recibe alertas y revisa grabaciones de movimiento.
            </div>
            <div className="card-features">
              <span>👁️ Múltiples cámaras</span>
              <span>🚨 Alertas en vivo</span>
              <span>🎞️ Historial clips</span>
            </div>
            <div className="card-cta viewer-cta">ABRIR PANEL →</div>
          </button>
        </div>

        {/* Info bar */}
        <div className="info-bar animate-in" style={{ animationDelay: '0.2s' }}>
          <div className="info-item">
            <span className="info-key">SERVIDOR</span>
            <span className="info-val">{window.location.hostname}</span>
          </div>
          <div className="info-sep">·</div>
          <div className="info-item">
            <span className="info-key">PROTOCOLO</span>
            <span className="info-val">WebRTC P2P</span>
          </div>
          <div className="info-sep">·</div>
          <div className="info-item">
            <span className="info-key">CIFRADO</span>
            <span className="info-val">DTLS-SRTP</span>
          </div>
          <div className="info-sep">·</div>
          <div className="info-item">
            <span className="info-key">NOTIF.</span>
            <span className="info-val">Telegram</span>
          </div>
        </div>
      </main>
    </div>
  );
}
